import { render } from "./EventVacancies.vue?vue&type=template&id=ee6c59c6"
import script from "./EventVacancies.vue?vue&type=script&lang=js"
export * from "./EventVacancies.vue?vue&type=script&lang=js"

import "./EventVacancies.vue?vue&type=style&index=0&id=ee6c59c6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__